// COMPORTAMIENTO CARRITO //

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-qty").forEach((qtyContainer) => {
    const minusBtn = qtyContainer.querySelector(".js-qty__adjust--minus");
    const plusBtn = qtyContainer.querySelector(".js-qty__adjust--plus");
    const inputField = qtyContainer.querySelector(".js-qty__num");
    const cantidadMinima = qtyContainer.querySelector(".cantidad_minima");
    const cantidadCaja = qtyContainer.querySelector(".cantidad_caja");
    const maxStock = qtyContainer.querySelector(".maxStock");
    const cargaCaja = qtyContainer.querySelector(".cargaCaja");

    if (!inputField) return;

    const stockMax = parseInt(maxStock?.value, 10) || 0;
    const valorCaja = parseInt(cantidadCaja?.value, 10);
    const valorMinimo = parseInt(cantidadMinima?.value, 10);

    let incremento, minimo;

    if (valorCaja) {
      incremento = valorCaja;
      minimo = valorCaja;
    } else if (valorMinimo) {
      incremento = 1;
      minimo = valorMinimo;
    } else {
      incremento = 1;
      minimo = 1;
    }

    let currentValue = parseInt(inputField.value, 10);
    if (isNaN(currentValue) || currentValue < minimo) {
      inputField.value = minimo;
    }

    // Mostrar carga de cajas al inicio si corresponde
    if (valorCaja) {
      cargaCaja.textContent = currentValue / valorCaja;
    }

    plusBtn?.addEventListener("click", () => {
      console.log("yerko");

      let currentValue = parseInt(inputField.value, 10) || 0;
      let newValue = currentValue + incremento;

      console.log("stockMax: ", stockMax);
      console.log("newValue: ", newValue);

      // Si hay una cantidad por caja definida, verificamos el stock máximo por cajas
      if (valorCaja) {
        // Calculamos el máximo de cajas disponibles según el stock
        const maxCajasDisponibles = Math.floor(stockMax / valorCaja);

        console.log("Max cajas disponibles:", maxCajasDisponibles);

        // Si el número de cajas que queremos agregar supera el stock disponible, no permitimos la acción
        if (newValue / valorCaja > maxCajasDisponibles) {
          const tooltip = tippy(cargaCaja, {
            content: `No puedes agregar más de ${maxCajasDisponibles} caja(s), sobrepasa el stock disponible.`,
            theme: "light",
            animation: "scale",
            duration: 500,
            placement: "top",
            trigger: "manual",
          });

          tooltip.show();
          setTimeout(() => tooltip.hide(), 2000); // Ocultar después de 2 segundos
          return; // Detener la ejecución si se pasa del stock
        }

        // Si no se excede, se muestra el número de cajas que se agregan
        cargaCaja.textContent = newValue / valorCaja;
      } else {
        // Si no es "Caja", manejamos el input normalmente
        if (newValue > stockMax) {
          const tooltip = tippy(inputField, {
            content: `No puedes agregar más de ${stockMax} unidades, sobrepasa el stock disponible.`,
            theme: "light",
            animation: "scale",
            duration: 500,
            placement: "top",
            trigger: "manual",
          });

          tooltip.show();
          setTimeout(() => tooltip.hide(), 2000);
          return; // Detener si se pasa del stock
        }
      }

      // Actualizar el valor del input con el nuevo valor
      inputField.value = newValue;
    });

    minusBtn?.addEventListener("click", () => {
      let currentValue = parseInt(inputField.value, 10) || 0;
      let newValue = currentValue - incremento;

      if (newValue < minimo) {
        showTooltip(`Cantidad mínima: ${minimo}`);
      } else {
        inputField.value = newValue;
        if (valorCaja) cargaCaja.textContent = newValue / valorCaja;
        inputField.dispatchEvent(new Event("change"));
      }
    });
  });
});

// FIN COMPORTAMIENTO CARRITO //

// POR MAYOR //
document.addEventListener("DOMContentLoaded", function () {
  var newPrice = null; // Variable para almacenar el precio original

  document.addEventListener("click", function (event) {
    let swatch = event.target.closest(".swatch-element");

    if (swatch && !swatch.hasAttribute("data-clicked")) {
      swatch.setAttribute("data-clicked", "true"); // Evita clics duplicados
      let cargaCaja = document.querySelector(".cargaCaja");
      const inputMin = document.querySelector(".cantidadMinima");
      const cantidadMinima = inputMin ? parseInt(inputMin.value) : 1;
      let cantidad = document.querySelector(".por_mayor").value; // Valor del input oculto
      let quantityInput = document.querySelector("#Quantity");
      let productPriceElement = document.getElementById("ProductPrice");
      let moneyElement = document.querySelector(".money");
      let custom_price = document.querySelector(".custom_price");
      let selectedValue = swatch.getAttribute("data-value"); // "Unitario" o "Caja"

      console.log("Seleccionado:", selectedValue);

      // Guardar el precio original solo la primera vez

      if (quantityInput) {
        if (selectedValue.toLowerCase() === "caja") {
          quantityInput.value = cantidad;
          quantityInput.min = cantidad;
          quantityInput.step = cantidad;

          if (inputMin) {
            inputMin.value = 1; // para evitar conflictos visuales
          }

          if (cargaCaja) {
            cargaCaja.textContent = 1;
            cargaCaja.style.display = "inline-flex";
          }

          quantityInput.style.display = "none";
        } else {
          const min = inputMin
            ? parseInt(inputMin.dataset.original || inputMin.value)
            : 1;
          quantityInput.value = min;
          quantityInput.min = min;
          quantityInput.step = 1;

          if (inputMin && inputMin.dataset.original) {
            inputMin.value = inputMin.dataset.original;
          }

          if (cargaCaja) {
            cargaCaja.textContent = 1;
            cargaCaja.style.display = "none";
          }

          quantityInput.style.display = "inline-flex";
        }

        quantityInput.dispatchEvent(new Event("input"));
      }

      // **Actualizar precio correctamente**
      setTimeout(() => {
        if (selectedValue.toLowerCase() === "caja") {
          let precio = parseFloat(productPriceElement.getAttribute("content")); // Esto asegura que precio es un número

          newPrice = precio * cantidad;

          let precioFormateado = newPrice
            .toFixed(0)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

          console.log(precioFormateado);
          custom_price.innerHTML = `<div class="unitario_mayor">$${precio
            .toFixed(0)
            .replace(
              /\B(?=(\d{3})+(?!\d))/g,
              "."
            )} - </div><div class="total_mayor">$${precioFormateado} <span>(${cantidad} unidades)</span></div>`;
        } else {
          precio = parseFloat(productPriceElement.getAttribute("content")); // Asegura que precio sea un número
          let precioFormateado = precio
            .toFixed(0)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          custom_price.textContent = `$${precioFormateado}`; // precio con formato
        }
      }, 300);

      setTimeout(() => swatch.removeAttribute("data-clicked"), 100); // Permite nuevos clics
    }
  });
  // 👇 FORZAR CLIC SI SOLO HAY UNA OPCIÓN Y ES "Caja"
setTimeout(() => {
  const swatches = document.querySelectorAll(".swatch-element");
  if (swatches.length === 1) {
    const swatch = swatches[0];
    const value = swatch.getAttribute("data-value")?.toLowerCase();
    if (value === "caja") {
      swatch.click(); // Forzar clic para activar toda la lógica
    }
  }
}, 300); // <-- Ajusta el tiempo si hace falta (200–500ms es común)

});
